import styled from 'styled-components';
import OutlineOpenIcon from '../assets/svg/OutlineOpenIcon';
import OutlineCloseIcon from '../assets/svg/OutlineCloseIcon';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const Wrapper = styled.section`
  background: var(--primary-primary-400, #8dd473);

  .container {
    position: relative;
    max-width: 1440px;
    padding: 6.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 48px;
  }

  h2 {
    color: var(--font-color-font-4, #fff);
    text-align: center;
    font-family: Instrument Sans;
    font-size: 64px;
    font-style: normal;
    font-weight: 700;
    line-height: 88px;
  }

  .label {
    display: flex;
    padding: 6px 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border: none;
    border-radius: 3px;
    background: var(--BG-Color, #f2f2f2);
    color: var(--primary-primary-600-f, #62aa48);
    font-family: Instrument Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    position: absolute;
    top: 5%;
    left: 17%;
    transform: rotate(7deg);
  }

  .faq-item {
    display: flex;
    padding: 1.5rem 0;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1.5px;
    align-self: stretch;
    border-top: 1px solid var(--primary-primary-300, #bae5ab);
    cursor: pointer;

    .content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      flex: 1 0 0;
      max-width: 70%;

      .question {
        color: var(--font-color-font-4, #fff);
        font-family: Instrument Sans;
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: 40px;
      }

      .svg-container {
        width: 10%;
        cursor: pointer;
      }

      .subtext {
        color: var(--font-color-font-4, #fff);
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .container {
      padding: 4.25rem;
      gap: 2.5rem;
    }

    h2 {
      font-size: 45px;
      line-height: 58px;
    }

    .label {
      top: 3%;
      left: 15%;
    }

    .faq-item {
      padding: 1rem 0;

      .content {
        .question {
          font-size: 24px;
          line-height: 36px;
        }

        .subtext {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .container {
      padding: 4rem 1.25rem 2rem 1.25rem;
      gap: 24px;
    }

    h2 {
      font-size: 32px;
      line-height: 40px;
    }

    .label {
      padding: 6px 12px;
      top: 2%;
      left: 17%;
      transform: rotate(7deg);
    }

    ul {
      padding: 0px;
    }

    .faq-item {
      display: flex;
      padding: 1.5rem 0;
      align-items: flex-start;
      justify-content: space-between;
      gap: 1.5px;
      align-self: stretch;
      border-top: 1px solid var(--primary-primary-300, #bae5ab);

      .content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        flex: 1 0 0;
        max-width: 85%;

        .question {
          font-size: 18px;
          line-height: 26px;
        }

        .svg-container {
          width: 10%;
          cursor: pointer;
        }

        .subtext {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }
`;

const HomePageList = [
  {
    ques: 'Why should I have a Floral Website?',
    content: () => (
      <>
        A flower shop website expands your Shop reach, enhances customer
        convenience, marketing efforts, and overall business efficiency in the
        digital landscape.
        <br />
        <br />
        Online Orders and Payments: A website allows customers to place orders
        online, streamlining the purchasing process. Additionally, online
        payment options enhance the convenience for both the customer and the
        flower shop.
        <br />
        <br />
        Analytics and Insights: BoostFloral Website can be equipped with
        analytics tools to track visitor behavior. This data can provide
        valuable insights into customer preferences, popular products, and other
        metrics that can inform business strategies. `
      </>
    ),
  },
  {
    ques: 'Why Choose BoostFloral to build my Flower Shop Website?',
    content: () =>
      'Best Floral Website Building & Best Florist Website Hosting. Simply put, BoostFloral is the easiest and most inexpensive way to have a beautifully customized Floral storefront. You have full control of your online store with tools and functionality specific for managing Florist websites and transactions.',
  },
  {
    ques: 'What is BoostFloral Website Builder?',
    content: () =>
      'A powerful but simple e-commerce Floral WebCMS (content management system) that is purpose-built to create and host Flower Shop websites.  The website builder allows Florists to choose from default themes and provides unlimited customization through simple draggable sections to add, remove and reposition website components. The website builder has a large selection of elements that can be added to your website with a simple button click and easily edited, allowing you to have a beautiful and unique Floral Website.',
  },
  {
    ques: 'What if I am not very technical?',
    content: () =>
      'BoostFloral is designed for non-technical users and can be set up with no coding at all.  The usability was designed to be intuitive and flexible for users with minimal complexity.  The platform also has an integrated Help section that includes step-by-step video and written instructions to explain the purpose of each feature.',
  },
  {
    ques: 'What if I don’t have time to build my own Floral website? ',
    content: () =>
      'BoostFloral is so simple that an entire website can easily be created and hosted within minutes.  If you want someone that can help you through this process, our designers are available to help tailor your website appearance to your liking.  They can load your products, provide creative guidance, help get your site created and launched, provide SEO and Web Traffic feedback, and keep your site fresh with new content and imagery.',
  },
  {
    ques: 'Can I add a Shopping Cart to my Florist website?',
    content: () =>
      'Yes! All BoostFloral websites are ecommerce sites, meaning they include a shopping cart and are intended to be used to sell products.',
  },
  {
    ques: 'Are Florist website SEO Tools included with BoostFloral Website builder? ',
    content: () =>
      'Yes!  With BoostFloral, you have the ability to make sure your website performs well in search rankings.  SEO is important to ensure you increase web traffic and orders, and BoostFloral helps you optimize your flower shop search profile.',
  },
  {
    ques: 'Can I keep my current website domain name?',
    content: () =>
      'Yes!  If you already have a website domain like many flower shops already do, you can keep that name and attach it to your BoostFloral website.  If you would like to start with a new domain name, we can also help you create a new domain name and attach it to your website.',
  },
  {
    ques: 'Does BoostFloral have a POS system for Florists?',
    content: () =>
      'Our customers are not locked into a single POS, but can choose whichever floral POS they are most comfortable with.  We are specifically partnered with The Floral POS and MAS Direct, and have direct integrations with each, which provides an excellent and easy to use Floral Management experience ',
  },
  {
    ques: 'Floral Point of Sale – Floral POS?',
    content: () =>
      'Our customers are not locked into a single POS, but can choose whichever floral point of sale they are most comfortable with.  We are specifically partnered with The Floral POS and MAS Direct, and have direct integrations with each, which provides an excellent and easy to use Floral Management experience.',
  },
];

const FeaturesPageList = [
  {
    ques: 'Is my website secure?',
    content: () => (
      <>
        Yes, BoostFloral is designed to provide a safe and user-friendly
        foundation for e-commerce websites, but like any site, a BoostFloral
        website could be hacked. However, BoostFloral includes many features
        that will help protect your content and data to prevent this from
        happening, and unlike other platforms, we take care of the security, so
        you don’t have to.
        <br />
        <br />
        <ul>
          <li>
            Patching and updates is a core part of website security, and we take
            this responsibility from you to ensure the latest patches are
            applied and that you have the latest security updates and bug fixes.
          </li>
          <li>
            SSL certificates are automatically assigned to every website to
            ensure data in transit is secure.
          </li>
          <li>
            We enforce a strong password policy with a mix of upper- and
            lower-case letters, numbers, and special characters, making it much
            more difficult for bad actors or automated tools to break into your
            website.
          </li>
          <li>
            We leverage Stripe for credit cards, accounts, and transactions to
            ensure PCI-DSS compliance for all financial concerns.
          </li>
        </ul>
      </>
    ),
  },
  {
    ques: 'How long does it take to build and launch my website?',
    content: () =>
      'Websites can literally be created and online in minutes.  After your website is created, you can spend as much time as you like customizing it however you choose.',
  },
  {
    ques: 'Will my website work on Mobile devices?',
    content: () =>
      'Yes, all websites are designed to be mobile-friendly and optimized for various devices, including smartphones, tablets, iPads, laptops, and PCs.',
  },
  {
    ques: 'If I use a wire service, can I still use BoostFloral to create and host my website?',
    content: () =>
      'There are no limitations to using whichever wire service you prefer. You have full control over which products you sell on your website, which you fill locally, and which you wire out.',
  },
  {
    ques: 'Can I have a custom floral website?',
    content: () =>
      'Yes. You can build your own custom floral website on BoostFloral. It is simple to create your own floral website design.',
  },
  {
    ques: 'Can I connect my email to my website domain?',
    content: () =>
      'Yes. You can have the same email domain as your website domain using BoostFloral. This gives you the ability to have a professional looking email.',
  },
  {
    ques: 'How are SEO changes made?',
    content: () =>
      'We give you the ability to update all Meta tags and keywords anytime you wish.  This allows you to study your analytics and make adjustments as needed.',
  },
];

const PricingPageList = [
  {
    ques: 'Does BoostFloral have any Fees?',
    content: () => (
      <>
        Only has 2 fees.
        <br />
        <br />
        1) The Monthly Subscription for building and hosting a website
        (Essential, Premium, Premium VIP)
        <br />
        2) A service fee of $5.99 or 4%, whichever is higher, is applied to each
        order. Florists can choose to pay this fee from the received amount, or
        to apply it to the customer during checkout (this means the customer
        pays it). This fee covers the credit card processing and servicing of
        the order.
      </>
    ),
  },
  {
    ques: 'What is the process for receiving payments on my website sales?',
    content: () =>
      'When you set up your website, you will specify an account where you would like your funds sent.  Funds from the sale of products on your website are sent directly to your bank account.',
  },
  {
    ques: 'Do you provide ongoing support and maintenance?',
    content: () =>
      'We are always there for our customers.  We are constantly improving the platform and adding new features and functionality to make the platform work better for you. If you have any questions or issues, our support team can always be reached at support@boostfloral.com',
  },
];

const FAQ = ({ comingFrom }) => {
  const [openIndex, setOpenIndex] = useState(-1);
  const location = useLocation();

  useEffect(() => {
    if (location?.hash === '#OpenFAQ') {
      setOpenIndex(0);
    }
  }, [location.hash]);

  const resolveList = (comingFrom) => {
    switch (comingFrom) {
      case 'home':
        return HomePageList;
      case 'feature':
        return FeaturesPageList;
      case 'pricing':
        return PricingPageList;
      default:
        return HomePageList;
    }
  };
  return (
    <Wrapper>
      <div className="container" id="OpenFAQ">
        <h2>Flower Shop Website Templates Frequently Asked Questions</h2>
        <ul className="w-100">
          {resolveList(comingFrom)?.map((item, index) => (
            <li
              key={index}
              className="faq-item"
              onClick={() =>
                setOpenIndex((state) => (state === index ? -1 : index))
              }
            >
              <div className="content">
                <p className="question">{item.ques}</p>
                {openIndex === index && (
                  <p className="subtext">{item.content()}</p>
                )}
              </div>
              <div className="svg-container">
                {openIndex === index ? (
                  <OutlineCloseIcon />
                ) : (
                  <OutlineOpenIcon />
                )}
              </div>
            </li>
          ))}
        </ul>
        <div className="label">FAQ's</div>
      </div>
    </Wrapper>
  );
};

export default FAQ;
